import type { AxiosError } from 'axios'
import { useRouterUtils } from '@/composables/use-router-utils'
import { RouterName } from '@/enums/router-name'
import { ErrorCode } from '~library/enums'

export function useCheckServerStatus() {
  const checkServerStatus = async (error: AxiosError): Promise<boolean> => {
    const router = useRouterUtils()
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
      router.replace({
        name: RouterName.ERROR,
        params: {
          errorCode: ErrorCode.SYSTEM_MAINTAIN
        }
      })
      return false
    }

    return true
  }

  return { checkServerStatus }
}
